// extracted by mini-css-extract-plugin
export default {"footerContainer":"footer_footerContainer__VReEh","privacyPolicy":"footer_privacyPolicy__VArUf"};